import React from "react";
import ReactMarkdown from "react-markdown";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import logo from "../images/LogoTextTransBlack.png";
import "../css/privacy_policy.css";

function BautaFitPrivacyPolicyPage() {
  const privacyPolicyMarkdown = `
  **BautaFit Privacy Policy**

  Last updated: July 7, 2026

  BautaFit is a workout logging app. This policy is short because the app is simple: your data never leaves your device.

  **Data collection**

  BautaFit does not collect any data. The app has no user accounts, no analytics, no advertising, no tracking, and makes no network requests. We (the developers) receive nothing about you or your usage of the app.

  **Data storage**

  Everything you enter — workouts, exercises, sets, bodyweight, and settings — is stored locally on your device in a database that only the app can access. Deleting the app deletes this data.

  **Data sharing**

  The app shares data with no one. The optional CSV export and database backup features create files that you explicitly choose where to send via the iOS share sheet; that sharing is entirely under your control.

  **Third-party services**

  BautaFit uses no third-party services, SDKs, or analytics providers.

  **Children's privacy**

  BautaFit does not collect data from anyone, including children.

  **Changes to this policy**

  If a future version of the app changes any of the above, this policy will be updated before that version is released.

  **Contact**

  Questions? Email [info@rootpi.xyz](mailto:info@rootpi.xyz).
  `;

  return (
    <div className="App">
      <Header
        subtitle={<img className="header-image-container" src={logo} alt="" />}
      />
      <main>
        <div>
          <div className="about-container markdown-content">
            <ReactMarkdown>{privacyPolicyMarkdown}</ReactMarkdown>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default BautaFitPrivacyPolicyPage;
